import {
  GqlError,
  GetVideoCallUsersQuery,
  GetVideoCallUsersDocument,
} from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'
import useSWR, { SWRConfiguration } from 'swr'

import { videoCallCacheKeys } from './cacheKey'

type GetVideoCallUsersRes = GetVideoCallUsersQuery['videoCallUsers']

const getVideoCallUsers = async ({
  videoCallUserUids,
}: {
  videoCallUserUids: number[]
}): Promise<GetVideoCallUsersRes> => {
  try {
    const res = await graphqlRequest(GetVideoCallUsersDocument, {
      videoCallUserUids,
    })
    return res.videoCallUsers
  } catch (error) {
    throw error
  }
}

export const useVideoCallUsers = ({
  videoCallUserUids,
  ...option
}: { videoCallUserUids: number[] } & SWRConfiguration<
  GetVideoCallUsersRes,
  GqlError
>) => {
  return useSWR(
    videoCallCacheKeys.getVideoCallUsers(videoCallUserUids),
    () => getVideoCallUsers({ videoCallUserUids }),
    option,
  )
}
